// ////////////////////////////スマホ/タブレット判別
var _ua = (function (u) {
  return {
    Tablet: (u.indexOf('windows') != -1 && u.indexOf('touch') != -1)
      || u.indexOf('ipad') != -1
      || (u.indexOf('android') != -1 && u.indexOf('mobile') == -1)
      || (u.indexOf('firefox') != -1 && u.indexOf('tablet') != -1)
      || u.indexOf('kindle') != -1
      || u.indexOf('silk') != -1
      || u.indexOf('playbook') != -1,
    Mobile: (u.indexOf('windows') != -1 && u.indexOf('phone') != -1)
      || u.indexOf('iphone') != -1
      || u.indexOf('ipod') != -1
      || (u.indexOf('android') != -1 && u.indexOf('mobile') != -1)
      || (u.indexOf('firefox') != -1 && u.indexOf('mobile') != -1)
      || u.indexOf('blackberry') != -1
  };
})(window.navigator.userAgent.toLowerCase());
// if(_ua.Mobile){}

var osVer;
osVer = 'Android';

// if (navigator.userAgent.indexOf(osVer)>0){
// }

var breakNum = 600;
var tabletNum = 1024;
// ////////////////////////////////////init
$(function () {
  setScroll();
  setHeader();
  // killClick()
  if (!$('#wrapper').hasClass('home')) {}
  // ///////////
  if (_ua.Tablet || _ua.Mobile) {} else {}
  // ///////////
  if (!_ua.Mobile) {}
});

$(window).on('load', function () {
  heightLineGroup();
  svg4everybody();
  judgeWinSize();
  setMainMenu();
  setPinBtn();
  // setMarquee()
  setAcc();
  setWay();
  setSVG();
  setLoaded();
  // setScrollTop()
  // setTextile()
  if ($('#wrapper').hasClass('home')) {
    // setMainVis()
  }
  if (!_ua.Mobile && !_ua.Tablet) {
    // setPal()
  }
});

// ///////ヘッダー制御
function setHeader () {
  fixedHeader();

  $(window).scroll(function () {
    fixedHeader();
  });

  window.addEventListener('resize', function () {
    if (currentWidth == window.innerWidth) {
      return;
    }
    currentWidth = window.innerWidth;
    if (timer !== false) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      $('#wrapper').removeClass('fixedHeader');
    }, 200);
  });

  function fixedHeader () {
    var h = 10;
    baseHeight = h;
    if ($(this).scrollTop() <= baseHeight) {
      $('#wrapper').removeClass('fixedHeader');
    }else if ($(this).scrollTop() > baseHeight) {
      $('#wrapper').addClass('fixedHeader');
    }
  }
}

// ピンタレストボタン
function setPinBtn () {
  $('.pinBtn').on('click', function () {
    $('.pinBtnWrap>span').click();
  });
}

// ///////クリップボードコピー
function setClip () {
  var clipboard = new ClipboardJS('.setClip');
  clipboard.on('success', function (e) {
    // コピー成功時
  });
  clipboard.on('error', function (e) {
    // エラー時
  });
}

// /////////////////インスタ
function setInstagram () {
  var limitNum = 0;
  // var setUrl
  limitNum = 40;
  // if ($('#wrapper').hasClass('home')) {
  //   limitNum = 32
  // }else {
  //   limitNum = 16
  // }
  $.ajax({
    type: 'GET',
    url: 'https://graph.facebook.com/v9.0/17841427049785609?fields=name%2Cmedia.limit(' + limitNum + ')%7Bcaption%2Clike_count%2Cmedia_url%2Cthumbnail_url%2Cpermalink%2Ctimestamp%2Cusername%7D&access_token=EAA9VdZBqZBUl0BANOmZBYy6KwuyafocQghxVgmrRLc9jjj5DEt9mtMK7JAF9rqnVeEMp6bRn4GiEd44ysilyB01KtzcBJxqZAKnipGplAejM5PjfZAFIYlHKzraAHN1IrLSsQfwo9YZC4Iq7ElLriwD1IdeQ7bdaOiWFk6UzHaiXavNWIVIQHQ',
    dataType: 'json',
    success: function (json) {
      var html = '';
      var insta = json.media.data;
      // var imgPath
      for (var i = 0; i < insta.length; i++) {
        if (insta[i].thumbnail_url) {
          imgPath = insta[i].thumbnail_url;
        }else {
          imgPath = insta[i].media_url;
        }
        //        if (!insta[i].media_url.match(/.mp4/)) {
        html += '<div class="infiniteItem"><a href="' + insta[i].permalink + '" target="_blank"><div class="imgStyle"><span><span><img src="' + insta[i].media_url + '" alt=""></span></span></div></a></div>';
        $('#instafeedSp').prepend('<div class="infiniteItem"><a href="' + insta[i].permalink + '" target="_blank"><div class="imgStyle"><span><span><img src="' + imgPath + '" alt=""></span></span></div></a></div>');
      //      }
      }
      $('#instafeed').append(html);
      $('#instafeedSp').append(html);
      setInfinite();
    },
    error: function () {}
  });
}

// /////////////////////////////無限スライダー
function setInfinite () {
  var pauseFlag;
  if (!_ua.Mobile) {
    pauseFlag = true;
  }else {
    pauseFlag = false;
  }
  $('.infiniteslide.style_01').infiniteslide({
    pauseonhover: pauseFlag,
    speed: 50
  });
  $('.infiniteslide.style_02').infiniteslide({
    pauseonhover: pauseFlag,
    direction: 'right',
    speed: 50
  });
}

// プルダウンセレクト条件設定
function setSubject () {
  $('select[name="subject-type"]').change(function () {
    var val = $(this).find('option:selected').val();
    $('.subjectTx').hide();
    if (val == 'ご予約について') {
      $('#subject_01').slideDown('fast');
      $('.setSubject textarea').val('1.ご希望の日時\n2.ご来店人数\n3.お名前\n4.お電話番号\n5.その他（アレルギー食材など）');
    }else if (val == 'お取り置きについて') {
      $('#subject_02').slideDown('fast');
      $('.setSubject textarea').val('1.お受け取りご希望の日時\n（フレジェのタルトはお引き取り予定2日前の20:00まで、その他は前日20:00までにご連絡ください）\n2.ご希望商品の内容\n3.個数\n4.お名前\n5.お電話番号');
    }else if (val == 'クリスマスケーキのご予約') {
      $('#subject_03').slideDown('fast');
      $('.setSubject textarea').val('1.お受け取りご希望の日時\n2.お名前\n3.お電話番号');
    }else {
      $('.setSubject textarea').val('');
    }
  });
}

// //////////////////////////フォーム制御
function setForm () {
  // URLのアンカー（#以降の部分）を取得
  var urlHash = location.hash;

  // URLにアンカーが存在する場合
  if (urlHash) {
    if (urlHash == '#reserve') {
      $('select[name=subject-type]').val('ご予約について');
      $('#subject_01').slideDown('fast');
      $('.setSubject textarea').val('1.ご希望の日時\n2.ご来店人数\n3.お名前\n4.お電話番号\n5.その他（アレルギー食材など）');
    }else if (urlHash == '#recruit') {
      $('select[name=subject-type]').val('採用について');
    }else if (urlHash == '#order') {
      $('#subject_02').slideDown('fast');
      $('select[name=subject-type]').val('お取り置きについて');
      $('.setSubject textarea').val('1.お受け取りご希望の日時（お引き取り予定前日の20:00までにご連絡ください）\n2.ご希望商品の内容\n3.個数\n4.お名前\n5.お電話番号');
    }else if (urlHash == '#order_01') {
      $('#subject_02').slideDown('fast');
      $('select[name=subject-type]').val('お取り置きについて');
      $('.setSubject textarea').val('1.お受け取りご希望の日時\n（フレジェのタルトはお引き取り予定2日前の20:00まで、その他は前日20:00までにご連絡ください）\n2.フレジェのタルト\n3.個数\n4.お名前\n5.お電話番号');
    }else if (urlHash == '#order_02') {
      $('#subject_02').slideDown('fast');
      $('select[name=subject-type]').val('お取り置きについて');
      $('.setSubject textarea').val('1.お受け取りご希望の日時\n（フレジェのタルトはお引き取り予定2日前の20:00まで、その他は前日20:00までにご連絡ください）\n2.トライアングル ショコラ\n3.個数\n4.お名前\n5.お電話番号');
    }else if (urlHash == '#order_xmas') {
      $('#subject_03').slideDown('fast');
      $('select[name=subject-type]').val('クリスマスケーキのご予約');
      $('.setSubject textarea').val('1.お受け取りご希望の日時\n2.お名前\n3.お電話番号');
    }
  }
  jQuery('.wpcf7-tel').attr('pattern', '\\d*');
  jQuery('.wpcf7-tel').attr('onkeyup', 'if(event.keyCode==9||event.keyCode==16) return; this.value=this.value.replace(/[^0-9]+/i,"")');

  $('#confirmBtn').on('click', function () {
    $('.wpcf7c-btn-confirm').click();
  });
  $('#backBtn').on('click', function () {
    $('.wpcf7c-btn-back').click();
  });
  $('#submitBtn').on('click', function () {
    $('.wpcf7-submit').click();
  });

  // /////エラーのとき
  document.addEventListener('wpcf7invalid', function (event) {
    setTimeout(function () {
      var position = $('.wpcf7-not-valid-tip:first').offset().top - 300;
      $('html,body').animate({
        scrollTop: position
      }, {
        queue: false
      });
    }, 100);
  }, false);
  // /////成功のとき
  document.addEventListener('wpcf7mailsent', function (event) {
    $('html,body').animate({
      scrollTop: 0
    }, {
      queue: false
    });
  }, false);
}

// ///////////////////////////フォーム確認画面
function setConfirm () {
  var tx = $('[name=company-name]').val();
  $('#companyTx').text(tx);

  var tx = $('[name=myname]').val();
  $('#nameTx').text(tx);

  var tx = $('[name=mytel]').val();
  $('#telTx').text(tx);

  var tx = $('[name=mymail]').val();
  $('#mailTx').text(tx);

  var tx = $('[name=subject-type]').val();
  $('#typeTx').text(tx);

  var tx = $('[name=content]').val();
  $('#contentTx').text(tx);
}

// プルダウンカスタム
function setPullDown () {
  $('.sel').each(function () {
    // $(this).children('select').css('display', 'none')
    var $current = $(this);
    var $price = $(this).next();
    $(this).find('option').each(function (i) {
      var priceTarget = 'li:nth-child(' + i + ')';
      var priceTx = $price.find(priceTarget).text();
      var priceTarget0 = 'li:nth-child(1)';
      var priceTx0 = $price.find(priceTarget0).text();
      if (i == 0) {
        $current.prepend($('<div>', {
          class: $current.attr('class').replace(/sel/g, 'sel__box')
        }));

        var placeholder = $(this).text();
        $current.prepend($('<span>', {
          class: $current.attr('class').replace(/sel/g, 'sel__placeholder'),
          html: '<span class="optionWrap"><span class="tx">' + $(this).text() + '</span>' + '<span class="priceTx">' + priceTx0 + '</span></span>',
          'data-placeholder': placeholder
        }));

        return;
      }
      $current.children('div').append($('<span>', {
        class: $current.attr('class').replace(/sel/g, 'sel__box__options'),
        html: '<span class="optionWrap"><span class="tx">' + $(this).text() + '</span>' + '<span class="priceTx">' + priceTx + '</span></span>'
      }));
    });
  });

  // Toggling the `.active` state on the `.sel`.
  $('.sel').click(function () {
    $(this).toggleClass('active');
  });

  // Toggling the `.selected` state on the options.
  $('.sel__box__options').click(function () {
    var txt = $(this).text();
    var htmls = $(this).html();
    var index = $(this).index();

    $(this).siblings('.sel__box__options').removeClass('selected');
    $(this).addClass('selected');

    var $currentSel = $(this).closest('.sel');
    $currentSel.children('.sel__placeholder').attr('data-placeholder', txt);
    $currentSel.children('.sel__placeholder').html(htmls);
    $currentSel.children('select').prop('selectedIndex', index + 1);

    // var setOption = $('select[name="select-option"] option:selected').val()
    $('.cartjs_option select').prop('selectedIndex', index);
  });

  $('.killerSelect,.itemAcc').on('click', function () {
    $('.sel').removeClass('active');
  });
}

// カラーミーショップデータセット
function setColorMe () {
  $('.cmBtn').on('click', function () {
    var box = $(this).parents('.itemUnit');
    var setNum = box.find('.numPress').val();
    box.find('.cartjs_product_num input').val(setNum);
    box.find('.cartjs_cart_in input').click();
  });
}

// /////////数字入力
function setNumPress () {
  // /数字入力制限
  $('.numPress').on('keypress', function (event) {
    return leaveOnlyNumber(event);
  });

  function leaveOnlyNumber (e) {
    var st = String.fromCharCode(e.which);
    if ('0123456789'.indexOf(st, 0) < 0) {
      return false;
    }
    return true;
  }

  $('.numPress').each(function () {
    var loadNum = $(this).val();
    // console.log(loadNum)
    if (loadNum == 1) {
      $(this).parents('.numInput').find('.setMinus').addClass('def');
    }
  });

  $('.numInput .btn').on('click', function () {
    var baseNum = $(this).parents('.numInput').find('input').val();
    if ($(this).attr('class').replace('btn ', '') == 'setMinus') {
      baseNum--;
      if (baseNum == 1) {
        if (!$(this).hasClass('def')) {
          $(this).addClass('def');
        }
      }
      if (baseNum <= 0) {
        baseNum = 1;
        if (!$(this).hasClass('def')) {
          $(this).addClass('def');
        }
      }
      $(this).parents('.numInput').find('input').val(baseNum);
    } else {
      if ($(this).parents('.numInput').find('.setMinus').hasClass('def')) {
        $(this).parents('.numInput').find('.setMinus').removeClass('def');
      }
      baseNum++;
      $(this).parents('.numInput').find('input').val(baseNum);
    }
  });
}

// ///////// /svg useのクロスドメイン対応
function setSVG () {
  var svgPath = 'assets/images/imgsvg.svg';
  // console.log(location.host)
  if (location.host == 'triangle-cafe.com' || location.host == 'triangle-cafe.local' || location.host == 'test.triangle-cafe.com') {
    var rootPath = $('body').data('tmpdir');
    svgPath = rootPath + '/assets/images/imgsvg.svg';
  }
  $.ajax({
    type: 'get',
    url: svgPath
  }).done(function (data) {
    var svg = $(data).find('svg');
    $('body').prepend(svg);
  });
}

// //////////////////////////メインメニュー
var current_scrollY;
function setMainMenu () {
  $('#menuBtn').on('click', function () {
    if (!$(this).hasClass('active')) {
      openFnc();
    }else {
      closeFnc();
    }
  });

  $('#clickBlocker').on('click', function () {
    closeFnc();
  });

  var winW = $(window).width();
  var timer = false;
  var currentWidth = window.innerWidth;
  window.addEventListener('resize', function () {
    winW = $(window).width();
    if (currentWidth == window.innerWidth) {
      return;
    }
    currentWidth = window.innerWidth;
    if (timer !== false) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      if (winW > tabletNum) {
        closeFnc();
      }
    }, 200);
  });
}

function openFnc () {
  current_scrollY = $(window).scrollTop();
  $('#menuBtn').addClass('active');
  $('#wrapper').addClass('menuOpen');
  $('#outerMenu').css('top', -(current_scrollY));
  setTimeout(function () {
    $('html, body').prop({
      scrollTop: 0
    });
  }, 100);
}

function closeFnc () {
  $('#menuBtn').removeClass('active');
  $('#outerMenu').css('top', '');
  $('#wrapper').removeClass('menuOpen');
  $('html, body').prop({
    scrollTop: current_scrollY
  });
  setTimeout(function () {
    $('#wrapper').removeClass('breakLuxy');
  }, 800);
}

// ////////////////////////////スライダー
function setCarousel01 () {
  var target = '.carouselStyle_01';
  $(target).each(function () {
    var slider = $(this).find('.screen');
    var slideCount = $(this).find('.screen>.carouselItem').length;
    var baseCount = slideCount + 1;
    var randomStart = Math.floor(Math.random() * slideCount);
    if (baseCount > 2) {
      slider.slick({
        initialSlide: randomStart,
        dots: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 8000,
        speed: 1000,
        fade: true,
        cssEase: 'linear'
      });
    }
    slider.on('touchmove', function (event, slick, currentSlide, nextSlide) {
      slider.slick('slickPlay');
    });
  });
}

function setCarousel02 () {
  var target = '.carouselStyle_02';
  $(target).each(function () {
    var slider = $(this).find('.screen');
    var slideCount = $(this).find('.screen>.carouselItem').length;
    var baseCount = slideCount + 1;
    if (baseCount > 2) {
      slider.slick({
        dots: true,
        pauseOnFocus: false,
        pauseOnHover: false,
        pauseOnDotsHover: false,
        pauseOnDotsHover: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 1000,
        fade: true,
        cssEase: 'linear'
      });
    }
    slider.on('touchmove', function (event, slick, currentSlide, nextSlide) {
      slider.slick('slickPlay');
    });
  });
}

function setCarousel03 () {
  var target = '.carouselStyle_03';
  $(target).each(function () {
    var slider = $(this).find('.screen');
    var slideCount = $(this).find('.screen>.carouselItem').length;
    var baseCount = slideCount + 1;
    if (baseCount > 2) {
      slider.slick({
        dots: true,
        pauseOnFocus: false,
        pauseOnHover: false,
        pauseOnDotsHover: false,
        pauseOnDotsHover: false,
        infinite: true,
        autoplay: false,
        // autoplaySpeed: 5000,
        speed: 1000,
        fade: true,
        cssEase: 'linear'
      });
    }
    slider.on('touchmove', function (event, slick, currentSlide, nextSlide) {
      slider.slick('slickPlay');
    });
  });
}
// ////////////////////////////アコーディオン
function setAcc () {
  $('.accStyle h3').on('click', function () {
    $(this).toggleClass('active');
    $(this).next().slideToggle('fast');
  });

  $('.itemAcc .accHead').on('click', function () {
    $(this).toggleClass('active');
    $(this).next().slideToggle('fast');
  });

  $('.faqAcc .accHead').on('click', function () {
    $(this).toggleClass('active');
    $(this).next().slideToggle('fast');
  });
}

// ////////////ウィンドウサイズを判別
function judgeWinSize () {
  var winW = $(window).width();
  if (winW > breakNum) {
    $('#wrapper').addClass('setPc');
  } else {
    $('#wrapper').addClass('setSp');
  }

  var timer = false;
  var currentWidth = window.innerWidth;
  window.addEventListener('resize', function () {
    if (currentWidth == window.innerWidth) {
      return;
    }
    currentWidth = window.innerWidth;
    if (timer !== false) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      winW = $(window).width();
      if (winW > breakNum) {
        $('#wrapper').addClass('setPc');
        $('#wrapper').removeClass('setSp');
      } else {
        $('#wrapper').addClass('setSp');
        $('#wrapper').removeClass('setPc');
      }
    }, 200);
  });
}

// //////////////////////////////ロード完了
function setLoaded () {
  $('#loading').addClass('loaded');
  $('#wrapper').addClass('loaded');
  $('body,html').animate({
    scrollTop: 0
  }, 0, 'swing');
}

// ///////waypoint
function setWay () {
  $('.way,.alphaWay,.scaleWay,.setAnimation,#bgTx>div,.nullWay').waypoint(function (direction) {
    var activePoint = $(this.element);
    if (direction === 'down') { // scroll down
      activePoint.addClass('active');
    }
  //    else{ //scroll up
  //        activePoint.removeClass('active')
  //    }
  }, {
    offset: '70%'
  });

  $('.shuffle').waypoint(function (direction) {
    var activePoint = $(this.element);
    if (direction === 'down') { // scroll down
      activePoint.addClass('active');
      // var container = $(this.element)
      activePoint.shuffleLetters();
    }
  //    else{ //scroll up
  //        activePoint.removeClass('active')
  //    }
  }, {
    offset: '70%'
  });

  $('.scaleway,.nullWay,.ttlStyle_05,.fade_01,.fade_02').waypoint(function (direction) {
    var activePoint = $(this.element);
    if (direction === 'down') { // scroll down
      activePoint.addClass('active');
    }
  //    else{ //scroll up
  //        activePoint.removeClass('active')
  //    }
  }, {
    offset: '70%'
  });
}

// /////////////////////////////スムーススクロール
function setScroll () {
  var headerHight = $('header').height() + 40;

  $('a[href^="#"]').click(function (e) {
    var href = $(this).attr('href');
    var target = $(href == '#' || href == '' ? 'html' : href);
    var position = target.offset().top - headerHight;

    if ($(this).hasClass('unqNav')) {
      closeFnc();
    }
    $.when(
      $('html, body').animate({
        scrollTop: position
      }, 400, 'swing'),
      e.preventDefault()
    ).done(function () {
      var diff = target.offset().top - headerHight;
      if (diff === position) {
      } else {
        $('html, body').animate({
          scrollTop: diff
        }, 10, 'swing');
      }
    });
  });
}

function startScroll () {
  // var headerHight = 0
  var headerHight = $('header').height() + 40;
  var href = $(location).attr('hash');
  if (href) {
    var target = $(href == '#' || href == '' ? 'html' : href);
    var position = target.offset().top - headerHight;

    $.when(
      $('html, body').animate({
        scrollTop: position
      }, 400, 'swing')
    ).done(function () {
      var diff = target.offset().top - headerHight;
      if (diff === position) {
      } else {
        $('html, body').animate({
          scrollTop: diff
        }, 10, 'swing');
      }
    });
  }
}

// ////////////////////////////////////ランドスケープ判定
var isLandscape = function () {
  if (window.innerHeight > window.innerWidth) {
    jQuery('body').addClass('portrait');
    jQuery('body').removeClass('landscape');
  } else {
    jQuery('body').addClass('landscape');
    jQuery('body').removeClass('portrait');
  }
};

if (_ua.Mobile) {
  jQuery(window).resize(function () {
    isLandscape();
  });
  isLandscape();
}

// //////////////////////////////高さ揃え
function heightLineGroup () {
  // setAutoHeight('#photoDiary .articleStyle_02 .inner')
  var winW = $(window).width();
  if (winW > breakNum) {
    // setAutoHeight('.setH_01 .headTtl')
    // setAutoHeight('.setH_01 h2')
    // setAutoHeight('#photoDiary .articleStyle_02 .inner')
    // setAutoHeight(".setH_01 .summary",3)
  } else {
    // setAutoHeight("#setH_08 h2",2)
  }

  startResize();
}

function setAutoHeight (target, count) {
  $(target).tile(count);
}

function startResize () {
  var timer = false;
  var currentWidth = window.innerWidth;
  window.addEventListener('resize', function () {
    if (currentWidth == window.innerWidth) {
      return;
    }
    currentWidth = window.innerWidth;
    if (timer !== false) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      heightLineGroup();
    }, 200);
  });
}
